export default __webpack_public_path__ + "static/media/no-data.49b76663.svg";